import React, { Component } from 'react';
import { getAppConfig } from 'common/util/configUtil';
import Zendesk from 'common/util/Zendesk/Zendesk';
import Popover from 'components/common/Popover/Popover';
import styles from './HelpMenu.scss';
import 'common/components/SupportWidget/external.scss';

const applicationSupportSettings = {
    helpCenter: { suppress: true },
    position: { horizontal: 'right', vertical: 'top' },
    offset: { horizontal: '50px', vertical: '70px' },
    zIndex: 100
};

export default class HelpMenu extends Component {
    constructor(props) {
        super(props);
        this.toggleZendesk = this.toggleZendesk.bind(this);
        this.zendesk = null;
    }

    initializeZendesk() {
        if (this.zendesk) return;

        this.zendesk = new Zendesk({ user: this.props.user });
        this.zendesk.setWidgetSettings(applicationSupportSettings);

        this.zendesk.loadWidget()
            .then(() => {
                this.zendesk.setUserIdentity();
            });
    }

    componentDidMount() {
        this.initializeZendesk();
    }

    componentWillUnmount() {
        if (this.zendesk) this.zendesk.logout();
    }

    toggleZendesk() {
        this.zendesk.toggleWidget();
    }

    render() {
        return (
            <Popover openDirection={'right'} target={<PopoverLabelClosed />} data-cy="HelpMenu">
                <PopoverLabelOpen />
                <HelpCenter />
                <SubmitTicket toggleZendesk={this.toggleZendesk} />
            </Popover >
        );
    }
}

const SubmitTicket = ({ toggleZendesk }) => {
    return (
        <div className={styles.helpMenu__link} onClick={() => toggleZendesk()} data-cy="HelpMenu-SubmitTicket">
            <p className={styles.helpMenu__linkLabel}>Submit A Ticket</p>
            <i className={styles.helpMenu__linkIcon}>chat_bubble_outline</i>
        </div>);
};

const HelpCenter = () => {
    const { corsOriginUrl } = getAppConfig();
    const redirectUrl = `${corsOriginUrl}/help-center`;

    return (
        <div className={styles.helpMenu__link} onClick={() => { window.open(redirectUrl, '_blank'); }} data-cy="HelpMenu-HelpCenter">
            <p className={styles.helpMenu__linkLabel}>Open Help Center</p>
            <i className={styles.helpMenu__linkIcon}>launch</i>
        </div >);
};

const PopoverLabelClosed = () => {
    return (
        <div className={styles.helpMenu__target} data-cy="HelpMenu-PopoverLabelClosed">
            <p className={styles.helpMenu__targetName}>Help</p>
            <i className={styles.helpMenu__targetIcon}>help</i>
            <i className={styles.helpMenu__targetIconArrow}>keyboard_arrow_down</i>
        </div>
    );
};

const PopoverLabelOpen = () => {
    return (
        <div className={styles.helpMenu__content} data-cy="HelpMenu-PopoverLabelOpen">
            <div className={styles.helpMenu__sudoTarget}>
                <p className={styles.helpMenu__sudoTargetName}>Help</p>
                <i className={styles.helpMenu__sudoTargetIcon}>help</i>
            </div>
        </div>
    );
};
